// 设置用户登录信息
export const SET_USER_LOGIN_INFO = (state, data) => {
  state.loginUserInfo = data;
  state.isLogged = data.AuthToken || false;
};

// 设置加载状态
export const SET_LOAD_STATUS = (state, status) => {
  state.isLoading = status;
};

// 设置购物车信息
export const SET_SHOPPING_CART = (state, data) => {
  state.shoppingCart = data;
};

/* ************************ 商品搜索 *********************** */

// 搜索商品结果 product list
export const SET_PRODUCT_SEARCH_RESULT = (state, data) => {
  state.searchProductList = data.ProductList;
};

// 搜索商品结果 filter output
export const SET_PRODUCT_FILTER_OUTPUT = (state, data) => {
  let filterSource = {};
  filterSource.filterOutputCategory = {
    attrName: '目录',
    attrValues: data.OutputCategories.map(item => {
      return {
        ...item,
        Check: false
      };
    }),
    indexArr: [],
    hasMoreOptions: false, // 是否可显示更多
    multiSelectEnabled: false, // 是否不可多选
    onMultiSelectView: false, // 多选视图
    onExpandView: false, // 是否展开
    key: 'filter-category'
  };
  filterSource.filterOutputManufacturer = {
    attrName: '品牌',
    attrValues: data.OutputManufacturers.map(item => {
      return {
        ...item,
        Check: false
      };
    }),
    indexArr: [],
    hasMoreOptions: false, // 是否可显示更多
    multiSelectEnabled: true, // 是否可以多选
    onMultiSelectView: false, // 多选视图
    onExpandView: false, // 是否展开
    key: 'filter-manufacturer'
  };
  filterSource.filterOutputSpecifications = data.OutputSpecifications.map((spec, index) => {
    return {
      id: spec.Id,
      attrName: spec.Name,
      attrValues: spec.SpecificationOptions.map(item => {
        return {
          ...item,
          Check: false
        };
      }),
      indexArr: [],
      hasMoreOptions: false,
      multiSelectEnabled: true, // 是否可以多选
      onMultiSelectView: false, // 多选视图
      onExpandView: false, // 是否展开
      key: 'filter-specification_item' + index
    };
  });
  filterSource.filterOutputAttributes = data.OutputAttributes.map((attr, index) => {
    return {
      id: attr.Id,
      attrName: attr.Name,
      attrValues: attr.AttributeValues.map(item => {
        return {
          Name: item,
          Check: false
        };
      }),
      indexArr: [],
      hasMoreOptions: false,
      multiSelectEnabled: true, // 是否可以多选
      onMultiSelectView: false, // 多选视图
      onExpandView: false, // 是否展开
      key: 'filter-attribute_item' + index
    };
  });
  state.searchFilterSources = filterSource;
};

export const SET_PRODUCT_FILTER_REFRESH = (state, data) => {
  state.searchFilterSources = data;
};
/* ************************ 商品搜索 *********************** */

// 个人中心地址信息
export const SET_USER_ADDRESS = (state, data) => {
  state.addressList = data;
};



// WEBPACK FOOTER //
// ./src/vuex/mutations.js